import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig'
import { FormListResp } from 'domain/payload/response/form/FormListResp';
import { FormDetailResp } from 'domain/payload/response/form/FormDetailResp';
import { FormSaveReq, FormFieldUploadImageResp } from 'domain/payload/request/form/FormSaveReq';
import { FormConfigResp } from 'domain/payload/response/form/FormConfigResp';

const FormService = () => {
  const formList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null,
    type?: string | null
  ): Promise<BaseResponse<FormListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/form/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size,
          type: type || undefined
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const formDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<FormDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/form/detail`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          id: id,
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const formConfig = async (
    token: string,
  ): Promise<BaseResponse<FormConfigResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/form/config`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const formSave = async (
    token: string,
    request: FormSaveReq
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/form/save`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const formDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/form/delete`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          id: id
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const formFieldUploadImage = async (
    token: string,
    formFieldId: string,
    file: File
  ): Promise<BaseResponse<FormFieldUploadImageResp>> => {
    try {
      const formData = new FormData();
      formData.append('formFieldId', formFieldId);
      formData.append('file', file);

      const response = await axiosInstance.post(`/v1/legacy/cms/form/field/upload-image`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response?.data?.message || error.message || 'Upload failed';
    }
  };

  return { 
    formList, 
    formDetail, 
    formConfig, 
    formSave, 
    formDelete, 
    formFieldUploadImage
  };
};

export default FormService;